module.exports = "/packs/images/sprites/footer_new_02~d9419610b2c7d5f95281f25ea1ba33e9.png";